export default {
  // Page title
  'page.title': 'Cronômetro',

  // How to use
  'howto.title': 'Como Usar',
  'howto.step1': 'Clique no botão "Iniciar" para começar o cronômetro, formato de exibição: minutos:segundos.centésimos',
  'howto.step2': 'Clique em "Pausar" para suspender a cronometragem quando o cronômetro estiver em execução, clique em "Iniciar" novamente para continuar',
  'howto.step3': 'Clique no botão "Reiniciar" para zerar o cronômetro e parar a cronometragem',
  'howto.step4': 'O cronômetro suporta exibição com precisão de milissegundos, adequado para cenários que exigem cronometragem precisa',

  // User reviews
  'reviews.title': 'Avaliações dos Usuários',
  'reviews.michaelRunner': 'Ferramenta essencial para treino! A precisão de milissegundos me permite registrar com exatidão cada desempenho de sprint, operação simples e rápida.',
  'reviews.chefJohnson': 'Mágica do temporizador de cozinha! Refogar, ferver macarrão, cozinhar ovos no vapor, tudo precisa de cronometragem precisa, este cronômetro me ajuda a fazer pratos perfeitos.',
  'reviews.sarahStudent': 'Essencial para simulação de provas! Usado para praticar o tempo de resposta, a interface limpa não distrai a atenção, melhorou minha eficiência nas respostas.',
  'reviews.coachWilliams': 'Ótimo assistente para aulas de treinamento! Treino intervalado e pranchas precisam de cronometragem precisa, os alunos adoram.',
  'reviews.drAnderson': 'O trabalho médico frequentemente requer cronometragem precisa, este cronômetro é simples e confiável, um ótimo assistente para meu trabalho clínico.',

  // User names
  'user.michaelRunner': 'Michael Corredor',
  'user.chefJohnson': 'Chef Johnson',
  'user.sarahStudent': 'Sarah Estudante',
  'user.coachWilliams': 'Treinador Williams',
  'user.drAnderson': 'Dr. Anderson',

  // Keywords section
  'keywords.stopwatch': 'cronômetro temporizador cronometragem precisa que horas são',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};